import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {createUserInfoPropType} from "../../../utils/propTypes";

class CreatePlayerOnTheGo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            initialInput: props.initialInput,
            inputtedEmail: null,
        };
    }

    onEmailChange() {
        this.setState({
            inputtedEmail: this.email.value,
        });
    }

    validateEmail(email) {
        // eslint-disable-next-line
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }


    renderButtons() {
        let haveValidEmail = false;

        if (this.state.inputtedEmail && this.validateEmail(this.state.inputtedEmail)) {
            haveValidEmail = true;
        }

        let addPlayerExtraClasses = 'bottom-button--disabled';
        let onAddPlayerClick = () => ({});

        if (haveValidEmail) {
            addPlayerExtraClasses = '';
            onAddPlayerClick = this.props.createUser;
        }

        return (
            <div className="bottom-button-bar">
                <div onClick={this.props.onCancel} className="bottom-button col-xs-4">Cancel</div>
                <div
                    onClick={() => onAddPlayerClick(this.state.inputtedEmail)}
                    className={`bottom-button col-xs-8 ${addPlayerExtraClasses}`}
                >Create user</div>
            </div>
        );
    }

    renderErrors() {
        if (this.props.createNewUserForm.error === '') {
            return null;
        }
        return (
            <div className="alert alert-danger">
                {this.props.createNewUserForm.error}
            </div>
        );
    }

    render() {
        return (
            <div className="create-player">
                <div className="container">
                    <div>
                        <p>Aaaaaargh, we do not have the user you were looking for in our system =( </p>
                        <p>No worries, we can easily create it. All we need to know is his/her email address.</p>

                        <label htmlFor="email" className="control-label">Email</label>
                        <input
                            name="email"
                            type="email"
                            datatype="email"
                            ref={(ref) => { this.email = ref; }}
                            className="textinput textInput form-control"
                            onChange={() => this.onEmailChange()}
                        />
                        {this.renderErrors()}
                        {this.renderButtons()}
                    </div>
                </div>
            </div>
        );
    }
}

CreatePlayerOnTheGo.propTypes = {
    initialInput: PropTypes.string.isRequired,
    createUser: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    createNewUserForm: createUserInfoPropType,
};

export default CreatePlayerOnTheGo;



// WEBPACK FOOTER //
// ./src/apps/create_game/components/CreatePlayerOnTheGo.js